import { SVGProps } from "react";

export default function ProfileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <path
        d="M24.4999 24.0003C28.9199 24.0003 32.4999 20.4203 32.4999 16.0003C32.4999 11.5803 28.9199 8.00031 24.4999 8.00031C20.0799 8.00031 16.4999 11.5803 16.4999 16.0003C16.4999 20.4203 20.0799 24.0003 24.4999 24.0003ZM24.4999 28.0003C19.1599 28.0003 8.49988 30.6803 8.49988 36.0003V40.0003H40.4999V36.0003C40.4999 30.6803 29.8399 28.0003 24.4999 28.0003Z"
        fill="#636567"
      />
    </svg>
  );
}
